import React, { FC, memo, useMemo } from "react";
import { Panorama } from "@pbe/react-yandex-maps";

import { Container, PanoramaWrapper } from "./styled";
import { useFeatureCardModule } from "../hooks/useFeatureCardModule";
import { useFeature } from "../../../hooks/feature/useFeature";
import { ContainerProps } from "../types";

export const YandexMapContainer: FC<ContainerProps> = memo(({ elementConfig }) => {
  const { feature } = useFeatureCardModule();
  const { coordinates } = useFeature(feature);
  const { options, style } = elementConfig || {};
  const { position, width } = options || {};

  const defaultPoint = useMemo(() => {
    if (position) return position;

    if (!coordinates) return undefined;

    return coordinates[0]?.[0]?.[0] && coordinates[0]?.[0]?.[1]
      ? [coordinates[0][0][1], coordinates[0][0][0]]
      : coordinates[0] && coordinates[1]
      ? [coordinates[1], coordinates[0]]
      : undefined;
  }, [position, coordinates]);

  return (
    <Container style={style}>
      <PanoramaWrapper>
        <Panorama
          width={width || 340}
          defaultPoint={defaultPoint}
          options={{
            controls: ["zoomControl", "panoramaControl", "fullscreenControl"],
            suppressMapOpenBlock: true,
          }}
        />
      </PanoramaWrapper>
    </Container>
  );
});
